import { render } from "./ConnectWallet.vue?vue&type=template&id=0c963a6c&scoped=true"
import script from "./ConnectWallet.vue?vue&type=script&lang=js"
export * from "./ConnectWallet.vue?vue&type=script&lang=js"

import "./ConnectWallet.vue?vue&type=style&index=0&id=0c963a6c&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/magic-shop-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c963a6c"]])

export default __exports__